/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ConfigurazioneFormTranslatedDTO } from '../model/configurazione-form-translated-dto';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EsercenteConfigurazioneFormBandoServiceInterface,
    GetConfigurazioneFormEsercenteRequestParams
} from './esercente-configurazione-form-bando.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EsercenteConfigurazioneFormBandoService extends BaseService implements EsercenteConfigurazioneFormBandoServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Restituisce la configurazione del form esercente del bando (form risolto, $dynamic espansi). Endpoint pubblico: leggibile anche senza autenticazione. Il path variable {idTp} accetta sia l\&#39;UUID sia il codice del bando (risolto entro il comune).
     * @endpoint get /api/v1/esercente/comuni/{slug}/tipi-pratica/{idTp}/configurazione-form-esercente
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getConfigurazioneFormEsercente(requestParameters: GetConfigurazioneFormEsercenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ConfigurazioneFormTranslatedDTO>;
    public getConfigurazioneFormEsercente(requestParameters: GetConfigurazioneFormEsercenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ConfigurazioneFormTranslatedDTO>>;
    public getConfigurazioneFormEsercente(requestParameters: GetConfigurazioneFormEsercenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ConfigurazioneFormTranslatedDTO>>;
    public getConfigurazioneFormEsercente(requestParameters: GetConfigurazioneFormEsercenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const slug = requestParameters?.slug;
        if (slug === null || slug === undefined) {
            throw new Error('Required parameter slug was null or undefined when calling getConfigurazioneFormEsercente.');
        }
        const idTp = requestParameters?.idTp;
        if (idTp === null || idTp === undefined) {
            throw new Error('Required parameter idTp was null or undefined when calling getConfigurazioneFormEsercente.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/esercente/comuni/${this.configuration.encodeParam({name: "slug", value: slug, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/tipi-pratica/${this.configuration.encodeParam({name: "idTp", value: idTp, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/configurazione-form-esercente`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ConfigurazioneFormTranslatedDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
